import React from 'react';
import { tx } from '@/translations/translations';

export const OrderSummary = ({
  text, language, subtotal, shippingFee, coupon, discount, total,
  couponCode, setCouponCode, couponError, couponLoading, onApplyCoupon, onRemoveCoupon,
}) => (
  <div className="border-t pt-4 space-y-2">
    <div className="flex justify-between text-sm text-slate-600">
      <span>{text.subtotal}</span><span>${subtotal.toFixed(2)} MXN</span>
    </div>
    <div className="flex justify-between text-sm text-slate-600">
      <span>{text.shipping}</span>
      {shippingFee === 0 ? (
        <span className="font-bold text-emerald-600" data-testid="shipping-free-line">
          {tx(language, 'GRATIS', 'FREE', 'חינם')}
        </span>
      ) : (
        <span>${shippingFee.toFixed(2)} MXN</span>
      )}
    </div>
    {coupon && (
      <div className="flex justify-between text-sm text-emerald-600 font-medium">
        <span className="flex items-center gap-1.5">
          🎫 {coupon.code}
          <button onClick={onRemoveCoupon} className="text-rose-500 hover:text-rose-700 text-xs underline" data-testid="remove-coupon">
            {tx(language, 'quitar', 'remove', 'הסר')}
          </button>
        </span>
        <span>−${discount.toFixed(2)} MXN</span>
      </div>
    )}
    <div className="flex justify-between text-lg font-bold text-slate-800 border-t pt-2">
      <span>{text.total}</span><span>${total.toFixed(2)} MXN</span>
    </div>
    {!coupon && (
      <div className="pt-2">
        <div className="flex gap-2">
          <input
            type="text"
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); onApplyCoupon(); } }}
            placeholder={tx(language, 'Código de descuento', 'Discount code', 'קוד הנחה')}
            className="flex-1 px-3 py-2 text-sm border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500"
            autoCapitalize="characters"
            autoCorrect="off"
            spellCheck="false"
            data-testid="coupon-input"
          />
          <button
            onClick={onApplyCoupon}
            disabled={couponLoading || !couponCode.trim()}
            className="px-3 py-2 bg-cyan-600 text-white text-sm font-medium rounded-lg hover:bg-cyan-700 disabled:opacity-50 disabled:cursor-not-allowed"
            data-testid="apply-coupon"
          >
            {couponLoading ? '...' : tx(language, 'Aplicar', 'Apply', 'החל')}
          </button>
        </div>
        {couponError && <p className="text-rose-500 text-xs mt-1" data-testid="coupon-error">{couponError}</p>}
      </div>
    )}
  </div>
);
